import { combineReducers } from '@reduxjs/toolkit'
import { scriptReducer } from './features/scriptSlice'
import authReducer from './features/auth/authSlice';
import { scriptListReducer } from './features/scriptListSlice';
import { scriptsCharactersReducer } from './features/scriptCharacters';

export const rootReducer = combineReducers({
    script: scriptReducer,
    auth: authReducer,
    scriptList: scriptListReducer,
    scriptCharacters: scriptsCharactersReducer,
  });
  export type RootState = ReturnType<typeof rootReducer>